import { createFileRoute } from '@tanstack/react-router';
import CustomerHealth from 'containers/CustomerHealth/Loadable';

export const Route = createFileRoute('/_authenticated/customerHealth')({
  component: CustomerHealth,
});
